import { render, staticRenderFns } from "./CommissionListUpdate.vue?vue&type=template&id=7c4bccdb"
import script from "./CommissionListUpdate.vue?vue&type=script&lang=js"
export * from "./CommissionListUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports